import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CapitalizePipe } from './pipes/capitalize.pipe';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { FieldNamePipe } from './pipes/field-name.pipe';

import { LoadingComponent } from './components/loading/loading.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [CapitalizePipe, SafeHtmlPipe, FieldNamePipe, LoadingComponent],
  exports: [CapitalizePipe, SafeHtmlPipe, FieldNamePipe, LoadingComponent],
  providers: [CapitalizePipe, SafeHtmlPipe, FieldNamePipe],
})
export class CommonFeatureModule {}
